// extracted by mini-css-extract-plugin
module.exports = {"EmployeeCard":"EmployeeCard__EmployeeCard___1hW-v","Card":"EmployeeCard__Card___1ikwL","Body":"EmployeeCard__Body___2c3_c"};